export default "__VITE_ASSET__B_wEx_LD__"